import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import FormGroup from "@mui/material/FormGroup";

import { useDispatch, useSelector } from "react-redux";

import { setSelectedSource } from "@/features/dataTableSlice";

export function DataSourceSelection(props) {
  const dispatch = useDispatch();
  const { selectedSource, index } = props;
  const typeGrouping = useSelector((state) => state.dataTable.typeGrouping);

  const OtherSelection = () => {
    return (
      <>
        <Button
          sx={{
            flex: 1,
          }}
          variant={selectedSource === "all_actual" ? "contained" : "outlined"}
          onClick={() => {
            dispatch(
              setSelectedSource({
                index,
                value: "all_actual",
              })
            );
          }}
        >
          all shop(actual)
        </Button>
        <Button
          sx={{
            flex: 1,
          }}
          variant={
            selectedSource === "promoter_actual" ? "contained" : "outlined"
          }
          onClick={() => {
            dispatch(
              setSelectedSource({
                index,
                value: "promoter_actual",
              })
            );
          }}
        >
          Promoter Shop(actual)
        </Button>
        <Button
          sx={{
            flex: 1,
          }}
          variant={
            selectedSource === "promoter_report" ? "contained" : "outlined"
          }
          onClick={() => {
            dispatch(
              setSelectedSource({
                index,
                value: "promoter_report",
              })
            );
          }}
        >
          Promoter Shop(Apps)
        </Button>
      </>
    );
  };
  const ShopSelection = () => {
    return (
      <>
        <Button
          sx={{
            flex: 1,
          }}
          variant={
            selectedSource === "promoter_actual" ? "contained" : "outlined"
          }
          onClick={() => {
            dispatch(
              setSelectedSource({
                index,
                value: "promoter_actual",
              })
            );
          }}
        >
          Promoter Shop(actual)
        </Button>
        <Button
          sx={{
            flex: 1,
          }}
          variant={
            selectedSource === "promoter_report" ? "contained" : "outlined"
          }
          onClick={() => {
            dispatch(
              setSelectedSource({
                index,
                value: "promoter_report",
              })
            );
          }}
        >
          Promoter Shop(Apps)
        </Button>
      </>
    );
  };
  return (
    <FormGroup sx={{ m: 1 }}>
      <ButtonGroup
        variant="contained"
        orientation="vertical"
        aria-label="Basic button group"
      >
        {typeGrouping === "shop" ? <ShopSelection /> : <OtherSelection />}
      </ButtonGroup>
    </FormGroup>
  );
}
